import { Component, EventEmitter, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'app-pallet-information-form',
  standalone: true,
  imports: [ReactiveFormsModule],
  templateUrl: './pallet-information-form.component.html',
  styleUrl: './pallet-information-form.component.scss'
})
export class PalletInformationFormComponent implements OnInit {
  @Input()
  formGroup!: FormGroup;
  @Input()
  disableEmitter!: EventEmitter<boolean>;

  constructor(private formBuilder: FormBuilder) { }

  getFormGroup() {
    return this.formGroup.get('palletInformation') as FormGroup;
  };

  ngOnInit() {
    this.disableEmitter.subscribe((value) => {
      if (value) {
        this.formGroup.disable({ emitEvent: false });
      } else {
        this.formGroup.enable();
      }
    });
    this.initializeForm();
  }

  initializeForm() {
    this.formGroup.addControl('palletInformation', this.formBuilder.group({
      totalLifts: this.formBuilder.control(0),
      chepPallets: this.formBuilder.control(0),
      loscamPallets: this.formBuilder.control(0),
      greenPallets: this.formBuilder.control(0),
      otherPallets: this.formBuilder.control(0),
    }));

    this.formGroup.get('palletInformation')?.valueChanges.subscribe((value) => {
      if (!value.totalLifts) {
        value.totalLifts = 0;
      }
      if (!value.chepPallets) {
        value.chepPallets = 0;
      }
      if (!value.loscamPallets) {
        value.loscamPallets = 0;
      }
      if (!value.greenPallets) {
        value.greenPallets = 0;
      }
      if (!value.otherPallets) {
        value.otherPallets = 0;
      }
      this.formGroup.get('palletInformation')?.patchValue(value, { emitEvent: false });
    });
  }
}
